<template>
  <div class="MinhasSimulacoes">
    <div class="row">
      <SideNavMinhasSimulacoes
        v-bind:visualizacaoSection="section"
        @AlteraSectionClick="alterarVisualizacao"
        @Pesquisar="AtualizarTermoDePesquisa"
      />
      <div class="col s12 m9 offset-m3" v-if="section == 'simulacoes'">
        <span v-for="(simulacao, chave) in simulacoes" :key="simulacao.title">
          <div
            class="col l4 m4 s6"
            v-if="!simulacao.excluded && simulacao.title.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().match(termoPesquisa)"
          >
            <CardSimulation
              v-bind:simulacao="simulacao"
              @DeleteSimulacaoClick="DeletarSimulacao"
              v-bind:tokenSimulacao="chave"
              section="simulacoes"
            />
          </div>
        </span>
      </div>
      <div class="col s12 m9 offset-m3" v-if="section == 'arquivados'">
        <span v-for="(simulacao, chave) in simulacoes" :key="simulacao.data">
          <div class="col l4 m4 s6" v-if="simulacao.excluded">
            <CardSimulation
              v-bind:simulacao="simulacao"
              @DeleteSimulacaoClick="DeletarSimulacao"
              @ExcluirSimulacaoClick="confirmarExclusao"
              @RestaurarSimulacaoClick="RestaurarSimulacao"
              v-bind:tokenSimulacao="chave"
              section="arquivados"
            />
          </div>
        </span>
      </div>
      <ModalConfirmDelete @confirmDelete="ExcluirSimulacao" />
    </div>
  </div>
</template>
<script>
import CardSimulation from "@/components/MinhasSimulacoes/CardSimulation.vue";
import SideNavMinhasSimulacoes from "@/components/MinhasSimulacoes/SideNavMinhasSimulacoes.vue";
import ModalConfirmDelete from "@/components/MinhasSimulacoes/ModalConfirmDelete.vue";
import firebase from "firebase";
import M from "materialize-css";
//import $ from "jquery";
export default {
  name: "TabMinhasSimulacoes",
  components: {
    CardSimulation,
    SideNavMinhasSimulacoes,
    ModalConfirmDelete
  },
  data() {
    return {
      unSelected: true,
      simulacaoObject: null,
      simulacoes: null,
      tokenSimulacao: null,
      excluindo: false,
      excluir: false,
      section: "simulacoes",
      termoPesquisa: ""
    };
  },
  mounted() {
    this.getSimulacoes();
  },
  methods: {
    getSimulacoes: function() {
      var db = firebase.database();
      var ref = db.ref(
        "users/" + firebase.auth().currentUser.uid + "/simulations"
      );
      ref.on("value", response => {
        this.simulacoes = response.val();
      });
    },
    ExcludedSimulacao: function(data, booleanResponse) {
      var db = firebase.database();
      var uid = firebase.auth().currentUser.uid;
      var db_location = "users/" + uid + "/simulations/" + data;
      var ref = db.ref(db_location);

      this.tokenSimulacao = data;

      ref.on("value", response => {
        this.simulacaoObject = response.val();
      });

      this.simulacaoObject.excluded = booleanResponse;

      ref.set(this.simulacaoObject);
    },
    DeletarSimulacao: function(data) {
      this.ExcludedSimulacao(data.token, true);
      M.toast({
        html: "Arquivado",
        classes: "orange darken-4"
      });
    },
    RestaurarSimulacao: function(data) {
      this.ExcludedSimulacao(data.token, false);
      M.toast({
        html: "Simulação Restaurada",
        classes: "grey darken-4"
      });
    },
    confirmarExclusao: function(data) {
      this.tokenSimulacao = data.token;
      var instance = M.Modal.init(document.querySelector("#deleteModal"));
      instance.open();
    },
    ExcluirSimulacao: function(data) {
      if (!data.delete) return false;

      var db = firebase.database();
      var uid = firebase.auth().currentUser.uid;
      var db_location = "users/" + uid + "/simulations/" + this.tokenSimulacao;
      var ref = db.ref(db_location);
      ref.remove();

      M.toast({
        html: "Simulação Excluída"
      });
    },
    alterarVisualizacao: function(data) {
      this.section = data.section;
    },
    AtualizarTermoDePesquisa: function(data) {
      this.termoPesquisa = data.termo;
    }
  }
};
</script>